// Quick Add to Cart functionality for product cards
class QuickAddToCart {
  constructor() {
    this.init();
  }

  init() {
    // Add event listeners to all quick add buttons
    document.addEventListener('click', this.handleQuickAddClick.bind(this));
  }

  handleQuickAddClick(event) {
    // Ensure event.target is a valid DOM element
    if (!event.target || typeof event.target.closest !== 'function') return;

    const quickAddBtn = event.target.closest(
      '.product-card__quick-add-size-btn'
    );
    if (!quickAddBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = quickAddBtn.dataset.variantId;
    const productId = quickAddBtn.dataset.productId;

    if (!variantId || !productId) {
      console.error('Missing variant or product ID');
      return;
    }

    this.addToCart(variantId, quickAddBtn);
  }

  async addToCart(variantId, buttonElement) {
    // Check if already processing to prevent duplicate adds
    if (buttonElement.dataset.processing === 'true') {
      return;
    }

    // Show loading state
    // Store original text in data attribute if not already stored
    if (!buttonElement.dataset.originalText) {
      buttonElement.dataset.originalText = buttonElement.innerHTML.trim();
    }
    const originalText = buttonElement.dataset.originalText;

    // Replace button content with loading spinner
    buttonElement.innerHTML =
      '<div class="lds-ring quick-add-spinner"><span></span><span></span><span></span><span></span></div>';
    buttonElement.dataset.processing = 'true';
    buttonElement.disabled = true;
    buttonElement.style.opacity = '0.7';

    try {
      // Get cart drawer reference
      const cartDrawer = document.querySelector('cart-drawer');

      // Prepare FormData (like the theme does)
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      // Add sections to render if cart drawer exists
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append(
          'sections',
          cartDrawer
            .getSectionsToRender()
            .map((section) => section.section)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add to cart');
      }

      const data = await response.json();

      // Keep spinner visible while cart drawer opens
      // Update cart drawer using renderContents if available
      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(data, true); // true = open the drawer
      }

      // Update cart counters
      this.updateCartCounters();

      // Reset button after delay (keep spinner during this time)
      setTimeout(() => {
        buttonElement.innerHTML = originalText;
        buttonElement.dataset.processing = 'false';
        buttonElement.disabled = false;
        buttonElement.style.opacity = '';
        buttonElement.style.backgroundColor = '';
        buttonElement.style.borderColor = '';
      }, 1500);
    } catch (error) {
      console.error('Error adding to cart:', error);

      // Show error feedback - replace spinner with error text briefly
      buttonElement.innerHTML = 'Error';
      buttonElement.style.backgroundColor = 'rgba(255, 0, 0, 0.1)';
      buttonElement.style.borderColor = 'rgba(255, 0, 0, 0.3)';

      // Reset button after delay
      setTimeout(() => {
        buttonElement.innerHTML = originalText;
        buttonElement.dataset.processing = 'false';
        buttonElement.disabled = false;
        buttonElement.style.opacity = '';
        buttonElement.style.backgroundColor = '';
        buttonElement.style.borderColor = '';
      }, 2000);
    }
  }

  updateCartCounters() {
    // Trigger cart counter update
    const cartCounterEvent = new CustomEvent('cart:updated');
    document.dispatchEvent(cartCounterEvent);
  }
}

// Initialize Quick Add functionality when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuickAddToCart();
  });
} else {
  new QuickAddToCart();
}
